import { useState } from "react"
import { Link } from "react-router-dom"
import { ArrowLeft, Mail, CheckCircle } from "lucide-react"
import client from "../api/client"

export default function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")
  const [successMessage, setSuccessMessage] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccessMessage("")
    setIsLoading(true)

    try {
      const response = await client.post("/auth/forgot-password", { email })
      setSuccessMessage(response.data.message)
      setEmail("")
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send reset link. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-end p-4 xl:pr-64 lg:pr-14 overflow-hidden">
  {/* 🔹 Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover"
    src="/images/login-bg.mp4" // 👈 same video as login/register
    autoPlay
    loop
    muted
    playsInline
  />

  {/* 🔹 Optional dark overlay for readability */}
  <div className="absolute inset-0 bg-black/40"></div>

  {/* 🔹 Foreground Content */}
  <div className="relative z-10 auth-card max-w-md w-full">
    {/* Header */}
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-accent-cyan/10 rounded-full mb-4">
        <Mail className="text-accent-cyan" size={32} />
      </div>
      <h1 className="text-xl lg:text-4xl font-bold mb-2">
        <span className="text-accent">Forgot Password</span>
      </h1>
      <p className="text-text-secondary">
        No worries, we'll send you reset instructions.
      </p>
    </div>

    {/* Success Message */}
    {successMessage && (
      <div className="mb-6 p-4 bg-green-500/10 border border-green-500 rounded-lg flex items-start gap-3">
        <CheckCircle
          className="text-green-500 flex-shrink-0 mt-0.5"
          size={20}
        />
        <div className="text-green-500 text-sm">{successMessage}</div>
      </div>
    )}

    {/* Error Message */}
    {error && <div className="error-message mb-6">{error}</div>}

    {/* Form */}
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="form-label">Email Address</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
          placeholder="Enter your email address"
          disabled={isLoading}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="btn-primary text-center justify-center w-full disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Sending..." : "Send Reset Link"}
      </button>
    </form>

    {/* Back to Login */}
    <div className="mt-6 text-center">
      <Link
        to="/login"
        className="inline-flex items-center gap-2 text-accent-cyan hover:text-accent-bright-cyan font-semibold transition-colors"
      >
        <ArrowLeft size={18} />
        Back to Login
      </Link>
    </div>
  </div>
</div>

  )
}
